// Currency helpers.
//
// Per the International Shipping backend contract, every price-bearing API
// response carries a bare currency CODE string — "INR" or "USD" — and all
// amounts are ALREADY converted server-side. The FE never computes currency;
// it only maps the code to a display symbol.
//
// ponytail: two codes today (binary INR/USD model). Add rows here if the
// backend ever returns more — no other change needed.

export const CURRENCY_SYMBOL = { INR: "₹", USD: "$" };

// currency code ("INR"/"USD") → display symbol. Unknown/absent → ₹ (domestic).
export const symbolFor = (code) => CURRENCY_SYMBOL[code] || "₹";
